<template>
  <div style="position:fixed;width:calc(100vw - 110px);height:calc(100vh - 50px);background:#000000;z-index:2;color:#ffffff;">


    <!--背景视频-->
    <video v-if="backgroundVideoShow" style="position:absolute;width:100%;height:100%;object-fit:cover;" autoplay loop muted>
      <source :src="videoList[currVideoNum]" type="video/mp4" />
    </video>

    <div style="position:absolute;top:71px;left:62px;">
      <p style="font-size:36px;font-weight:bold;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">地球录制</p>
      <p style="margin-top:35px;font-size:20px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">吉林一号·共生地球3D地球动画创作工具</p>

      <!--预约按钮-->
      <div @click="sendApplication" v-if="!hasSendApplication" style="width:200px;height:56px;background:rgba(0, 102, 219, 1);border-radius:15px;margin-top:50px;cursor:pointer;text-align:center;">
        <p style="line-height:56px;font-size:20px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">预约功能体验</p>
      </div>
      <!--已预约-->
      <p v-if="hasSendApplication" style="margin-top:75px;color:rgba(0, 255, 242, 1);font-size:20px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">√  已提交预约申请，敬请期待</p>
    </div>

    <div style="position:absolute;left:50%;bottom:38px;transform:translate(-50%);width:469px;height:100px;display:flex;">
      <div @click="changeBackgroundVideo(0)"
           :style="{'background':currVideoNum === 0 ? 'rgba(52, 191, 107, 0.6)' : 'rgba(56, 56, 56, 0.6)'}"
           style="width:220px;height:100%;border-radius:15px;padding-left:18px;backdrop-filter:blur(10px);cursor:pointer;display:flex;flex-direction:column;justify-content:center;">
        <p style="font-size:18px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">喜马拉雅山环绕</p>
        <p style="margin-top:12px;font-size:16px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">卫星视角看喜马拉雅山</p>
      </div>
      <div @click="changeBackgroundVideo(1)"
           :style="{'background':currVideoNum === 1 ? 'rgba(52, 191, 107, 0.6)' : 'rgba(56, 56, 56, 0.6)'}"
           style="width:220px;height:100%;border-radius:15px;margin-left:29px;padding-left:18px;backdrop-filter:blur(10px);cursor:pointer;display:flex;flex-direction:column;justify-content:center;">
        <p style="font-size:18px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">城际模拟飞行</p>
        <p style="margin-top:12px;font-size:16px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">快捷预览城市景点</p>
      </div>
    </div>



<!--    <div ref="sceneDefaultMap" id="sceneDefaultMap"-->
<!--         style="position:absolute;top:0;left:-40%;width:140%;height:100%;background:#000000;"></div>-->

<!--    <div style="position:absolute;right:0;top:0;width:35%;height:100%;color:#ffffff;">-->
<!--      <div style="position:relative;top:45%;transform:translate(0,-50%);">-->
<!--        <p style="font-size:36px;font-weight:bold;">地球录制</p>-->
<!--        <p style="margin-top:35px;font-size:20px;">吉林一号·共生地球3D地球动画创作工具</p>-->
<!--        <p style="margin-top:85px;font-size:20px;">敬请期待……</p>-->
<!--      </div>-->
<!--    </div>-->

  </div>

</template>

<script>
// import mapboxgl from "mapbox-gl";

export default {
  name: "MainGlobeSceneDefault",

  data(){
    return{

      videoList:[
          "https://market.obs.cn-north-4.myhuaweicloud.com:443/202405281447000229925.mov",
          "https://market.obs.cn-north-4.myhuaweicloud.com:443/202405281450000454315.mp4"

      ],
      currVideoNum:0,

      backgroundVideoShow:true,

      //预约相关
      hasSendApplication:false,


    }

  },

  methods:{

    // initSceneDefaultMapbox() {
    //   mapboxgl.accessToken = this.$utils.mapboxToken;
    //   this.map = new mapboxgl.Map({
    //     container: 'sceneDefaultMap',
    //     zoom: 1,
    //     center:[90.94487491007658, 39.86471240059555],
    //     style: this.$utils.mapboxStyle,
    //     preserveDrawingBuffer:true,
    //     interactive:false,
    //     projection: {name:'globe'},
    //     transformRequest: (url) => {
    //       if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
    //         return {
    //           url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
    //         };
    //       }
    //     },
    //   });
    //   this.map.on('load', ()=>{
    //     this.map.setFog({
    //       "horizon-blend": 0.1,
    //       "space-color": 'rgba(0, 0, 0, 1)',
    //       "star-intensity": 0.15
    //     })
    //
    //     //图层列表
    //     this.map.addSource('world1m2021', {
    //       type: 'raster',
    //       tiles: [
    //         this.$utils.world1m2021
    //       ],
    //       tileSize: 256,
    //       scheme: 'tms'
    //     });
    //     this.map.addLayer({
    //       id: 'layer',
    //       type: 'raster',
    //       source: 'world1m2021'
    //     });
    //
    //
    //
    //     setInterval(()=>{
    //       this.spinGlobe()
    //     },1000)
    //
    //
    //
    //
    //   });
    //
    //
    // },
    //
    // //地球旋转
    // spinGlobe() {
    //   const secondsPerRevolution = 90;
    //   let distancePerSecond = 360 / secondsPerRevolution;
    //   const center = this.map.getCenter();
    //   center.lng += distancePerSecond;
    //   this.map.easeTo({ center, duration: 1000, easing: (n) => n });
    // }

    changeBackgroundVideo(videoNum){
      this.backgroundVideoShow = false;
      this.currVideoNum = videoNum
      setTimeout(()=>{
        this.backgroundVideoShow = true;
      },0)

    },


    //是否预约过
    getApplicationStatus(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-screen-recorder-application/getApplication",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.hasSendApplication = resultData.data.hasApplied;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },

    //发送预约申请
    sendApplication(){
      this.$axios({
        method:"post",
        url:"/authorApi/z-screen-recorder-application/apply",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.hasSendApplication = true;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    }

  },
  mounted(){
    // let temp = setInterval(()=>{
    //   if(this.$store.state.mapboxTokenIndex){
    //     this.initSceneDefaultMapbox()
    //     clearInterval(temp)
    //   }
    // })

    this.getApplicationStatus()



  }


}
</script>

<style scoped>

</style>